import { SyncOutlined } from "@ant-design/icons";
import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  gap: 12px;

  @media screen and (max-width: 400px) {
    gap: 8px;
  }
`;

export const WalletContainer = styled.div`
  display: flex;
  height: 70px !important;
  gap: 8px;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
  padding-left: 16px;
  border-radius: 12px;
  background: #0095da;
  box-shadow: 0px 3px 8px 0px #00000033;
  flex: 0.7;

  @media screen and (max-width: 400px) {
    gap: 4px;
  }

  @media screen and (max-width: 390px) {
    svg {
      width: 20px;
    }
  }

  @media screen and (max-width: 330px) {
    padding: 3px 6px;
  }
`;

export const WalletDataContainer = styled.div`
flex: 1;
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export const WalletTitle = styled.div`
  color: #ffe194;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

export const TopUpAndWithDrawContainer = styled.div`
  flex: 0.3;
  width: 100%;
  display: flex;
  gap: 10px;
  justify-content: space-between;
`;

export const ActionButton = styled.div`
  display: flex;
  height: 70px;
  width: 70px;
  gap: 4px;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  cursor: pointer;
  flex: 1;
  border-radius: 50% !important;
  background: #0095DA;
  box-shadow: 0px 3px 8px 0px #00000033;

  @media screen and (max-width: 390px) {
      svg {
          width: 20px;
      }
  }
`;

export const Text = styled.div`
  color: #FFF;
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;

  @media screen and (max-width: 340px) {
    font-size: 10px;
  }
`;

export const BalanceText = styled(Text)`
  flex: 1;
  text-align: left;
  padding: 0;
  position: relative;
  color: #ffffff;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  @media screen and (max-width: 390px) {
    font-size: 12px;
  }

  @media screen and (max-width: 340px) {
    font-size: 10px;
  }
`;

export const ReloadIcon = styled(SyncOutlined)`
margin-right: 16px;
font-size: 20px;
color: #fff;
`;